module.exports = __webpack_public_path__ + "img/blfgc01_center_002.c2db6509.png";